import AI from "../../assets/projects/works/Thumbnail_GFX_AI.png"
import SP from "../../assets/projects/works/Thumbnail_GFX_SP.png"
import WWR from "../../assets/projects/works/Thumbnail_GFX_WWR.png"
import HBU from "../../assets/projects/works/Thumbnail_VFX_HBD.png"
import PKO from "../../assets/projects/works/Thumbnail_VFX_PKO.png"
import TTZ from "../../assets/projects/works/Thumbnail_VFX_TTZ.png"
import DAY from "../../assets/projects/works/Thumbnail_GFX_days.jpg"
import ALT from "../../assets/projects/works/Thumbnail_VFX_alert.jpg"
import POD from "../../assets/projects/works/Thumbnail_VFX_podium.jpg"
import FAR from "../../assets/projects/works/Thumbnail_GFX_farm.jpg"
import CW from "../../assets/projects/works/InColdWaterPoster.png"
import LU from "../../assets/projects/works/LvlUpPoster.png"
import CIGAW from "../../assets/projects/works/cigawPoster.png"
import MMTZ from "../../assets/projects/works/MMTZPoster.png"
import CIH from "../../assets/projects/works/CIH_Poster.png"
import HLS from "../../assets/projects/works/HLS_Poster.png"
import INLT from "../../assets/projects/works/INLT_Poster.png"
import SFDP from "../../assets/projects/works/SFDP_Poster.png"
import CDWM from "../../assets/projects/works/CDWM_Poster.png"
import FRU from "../../assets/projects/works/freaks_Poster.png"
import MLWWB from "../../assets/projects/works/MLWWB_Poster.png"

import AIV from "../../assets/projects/videos/AgeOfAI.mp4"
import SPV from "../../assets/projects/videos/Sidney.mp4"
import WWRV from "../../assets/projects/videos/WomenWhoRock.mp4"
import HBUV from "../../assets/projects/videos/HomeB4Dark.mp4"
import PKOV from "../../assets/projects/videos/Pachinko.mp4"
import TTZV from "../../assets/projects/videos/TwilightZone.mp4"
import DAYV from "../../assets/projects/videos/500DaysInTheWild.mp4"
import ALTV from "../../assets/projects/videos/Alert.mp4"
import PODV from "../../assets/projects/videos/beyondPodium.mp4"
import FARV from "../../assets/projects/videos/FarmingForLove.mp4"
import CWV from "../../assets/projects/videos/InColdWater.mp4"
import LUV from "../../assets/projects/videos/LevelUp.mp4"
import CIGAWV from "../../assets/projects/videos/CanIGetAWitness.mp4"
import MMTZV from "../../assets/projects/videos/MyMotherZombie.mp4"
import CIHV from "../../assets/projects/videos/CIH.mp4"
import HLSV from "../../assets/projects/videos/HLS.mp4"
import INLTV from "../../assets/projects/videos/INLT.mp4"
import SFDPV from "../../assets/projects/videos/SFDP.mp4"
import CDWMV from "../../assets/projects/videos/CDWM.mp4"
import FRUV from "../../assets/projects/videos/FRU.mp4"
import MLWWBV from "../../assets/projects/videos/MLWWB.mp4"

const VFX = "VFX";
const GFX = "GFX";

export const dataWork = [

  {
    "id": 1,
    "title": "My Life with the Walter Boys",
    "genericDescription":
      `Jackie Howard's life is disrupted by a freak accident,
      she is ripped from her home and has to start over on a ranch in Colorado,
      with her guardian and a family of nine boys and one girl.`,
    "companyDescription":
      ``,
    "image": MLWWB,
    "video": MLWWBV,
    "type": [VFX],
    "roles": {
      "Creator": ["Melanie Halsall"],

    },
  },
  {
    "id": 2,
    "title": "500 Days in the Wild",
    "genericDescription": 
      `Dianne Whelan spends six years travelling the entire length of the Trans 
      Canada trail, across land and water trails from sea to sea.`,
    "companyDescription": 
      `In our first chat, Whelan pointed out she didn’t want clean maps. She wanted them to feel 
      alive, and tactile, which pushed us to create the watercolour style used in the film. In addition 
      to the maps, we also created a custom animated font based on Whelan’s handwriting, used both on the 
      maps and to indicate locations and time jumps in the film.`,
    "image": DAY,
    "video": DAYV,
    "type": [GFX],
    "roles": {
      "Director": ["Dianne Whelan"],
      "Writers": ["Tanya Maryniak", "Dianne Whelan"],
    	"Post Supervisor": ["Betsy Carson"]
    }
  },
  {
    "id": 3,
    "title": "Hitler's Last Stand",
    "genericDescription":
      `As the end of WWII approaches, diehard Nazi forces fight to the end to stop Allied armies from freeing Europe.`,
    "companyDescription":
      `Across 8 episodes and 1,116 shots, our work focused heavily on action and practical-effects enhancement,
      delivered on a fast turnaround. The scope included period-accurate muzzle flashes and explosions designed to
       match the era, alongside blood and gore work, wounds, bullet impacts, contact gunshots, and other action-driven
       effects. A key part of the work was ensuring every effect felt grounded in the photography and appropriate to
       the period rather than overly modern or stylized.`,
    "image": HLS,
    "video": HLSV,
    "type": [VFX],
    "roles": {
      "Creators": ["Ian Herring","Maija Leivo"],
    }
  },
  {
    "id": 4,
    "title": "Alert: Missing Person's Unit",
    "genericDescription":
      `Follows Nikki Batista after she joins the Philadelphia Police Department's
      Missing Person's Unit to help other people find their loved ones at the same time
      that she is looking for her missing son.`,
    "companyDescription":
      `By joining the post-production team very late on Alert, we had the mission to create
      elaborate graphics that were consistent with the episodes which had already aired. Playing
      to our strengths, we were also responsible for integrating the graphics into the plates,
      demonstrating proficiency in both VFX and GFX. We were on a race against time as every
      episode that landed on our plate was scheduled to air shortly!`,
    "image": ALT,
    "video": ALTV,
    "type": [VFX, GFX],
    "roles": {
      "Created by": ["John Eisendrath", "Jamie Foxx"],
    	"Post Supervisor": ["Jadene Babcock"]
    }
  },

  {
    "id": 5,
    "title": "Farming for Love",
    "genericDescription": 
      `Five young Canadian farmers, all from different farming specialties, meet prospective partners and choose if they wish 
      to pursue a romance. Over time, eliminations occur, with the aim of finding the ultimate partner.`,
    "companyDescription": 
      `CTV’s rural dating show needed lower thirds and an opener that could be repurposed as a bumper for transitions. 
      For the title, we worked with an already approved design, and leaned hard into all things romance: handwriting, 
      sparkles, and a sweeping shot of Canadian farmland.`,
    "image": FAR,
    "video": FARV,
    "type": [GFX],
    "roles": {
      // "Production": ["CTV", "Lark Productions"],
    	"Post Supervisor": ["Mike Krieg"]
    }
  },
  {
    "id": 6,
    "title": "Sidney",
    "genericDescription": 
      `Historians and film experts honours the legendary Sidney Poitier and his legacy as an iconic actor, filmmaker and 
      activist at the centre of Hollywood and the Civil Rights Movement.`,
    "companyDescription": 
      `Sidney has a very tactile approach to its overlay windows and graphics, which pushed us to build custom frames and 
      templates. Those helped navigate the complex story transitions while also providing context to upcoming segments. 
      We integrated tons of analog texture into the graphics such as gate weave, halation, grain, and many more, supporting 
      the storytelling by blending the graphics with the technical characteristics of Poitier’s film history.`,
    "image": SP,
    "video": SPV,
    "type": [GFX],
    "roles": {
      "Director": ["Reginald Hudlin"],
      "Writer": ["Jesse James Miller"],
    	"Post Supervisor": ["Jadene Babcock"]
    }
  },
  {
    "id": 7,
    "title": "Searching for Drug Peace",
    "genericDescription":
      `Amidst a deadly overdose crisis, a Vancouver activist defies the law by operating an illegal
      drug store that funds a drug-checking centre - risking everything to provide life-saving harm
      reduction and challenge the War on Drugs.`,
    "companyDescription":
      `While designing the opening credits, the vision from Alisher was "analog texture", so we resorted to creative
       light leak mattes, warmer color tones, and lots of grain. The film's theme of shedding light on
       the topic was also a big influence on the title card.`,
    "image": SFDP,
    "video": SFDPV,
    "type": [GFX],
    "roles": {
      "Director": ["Alisher Balfanbayev"],
      "Writers": ["Alisher Balfanbayev","Max Walter Joelson", "Liam Sherriff"],

    }
  },
  {
    "id": 8,
    "title": "Can I Get A Witness?",
    "genericDescription":
      `In a not so distant future, there is a reality where in order to save the planet,
      "death is everyone's job", with 50-year-olds taking the sacrifice, while teenage
      artists need to document it.`,
    "companyDescription":
      `For Fleming’s feature, we were tasked with creating a title card the captured the main character’s
      illustrations, as well as integrate it with a VFX shot. For that we worked with custom fonts and animation,
      benefitting from our understanding of VFX to deliver a seamless experience. We were also responsible for
      the end credits, and for that we used dozens of original artworks created for the film, delivering simple
      elegant animations in conjunction with a credit crawl that matched the style.`,
    "image": CIGAW,
    "video": CIGAWV,
    "type": [GFX],
    "roles": {
      "Director": ["Ann Marie Fleming"],
      "Writer": ["Ann Marie Fleming"],
    	"Post Supervisor": ["Diana NoLi"]
    }
  },

  {
    "id": 9,
    "title": "In Cold Water - The Shelter Bay Mystery",
    "genericDescription":
      `Canadian teacher Laura Letts-Beckett drowned in 2008.
      Her husband Peter claimed an accident, but police suspected
      he murdered her in the BC wilderness. Was it a tragic mishap or cold-blooded crime?`,
    "companyDescription":
      `We created all the graphics for Neufeld’s true crime docuseries,
      exploring different iterations of timelines, locators, and lower
      thirds that communicated the tense energy of the show.
	    For the title sequence, we enhanced a series of plates captured during
      production by dirtying up the water, creating depth through the use of foreground
      elements. We integrated the credits with simple water-like animation and displacement.`,
    "image": CW,
    "video": CWV,
    "type": [GFX],
    "roles": {
      "Director": ["Trish Neufeld"],
      "Writers": ["Alexis Adams", "Kyle Gunther"],
    	"Post Supervisor": ["Ryan Clarke"]
    }
  },
  {
    "id": 10,
    "title": "Menopause: Coming in Hot",
    "genericDescription":
      `When a strong-willed perimenopausal documentary filmmaker is told there isn't a
       lot of help available for her symptoms, she goes on mission to find out more about menopause,
        and ends up on a quest that makes her relearn everything she thought she knew about aging.`,
    "companyDescription":
      `Kate Green's graphics for Menopause were quirky, and fun, and aimed at making the subject of
      the film feel more approachable and easier to discuss, as well as encompassing of her energy as a director.`,
    "image": CIH,
    "video": CIHV,
    "type": [GFX],
    "roles": {
      "Director": ["Kate Green"],
      "Writers": ["Olivia Fellows","Tami Gabay","Kate Green"],

    }
  },
  {
    "id": 11,
    "title": "Freaks Part II",
    "genericDescription":
      `Mary and her daughter Chloe live on the road, hiding their identities from a world that wants to exterminate
      "freaks" like them. Chloe's longing for a friend throws her mom's
      plans into chaos and unlocks secrets that have been long buried.`,
    "companyDescription":
      `Having been part of the original team behind Freaks Underground I, we were excited when Zach brought us back
      for the second film with an even more ambitious set of ideas. Across 45 shots, the work ranged from extensive
      blood and gore integration to environmental treatments, sky replacements, weather effects, and atmosphere work.
      The project gave us room to push the visual language of the film while keeping the effects integrated
      with the world captured on set.`,
    "image": FRU,
    "video": FRUV,
    "type": [VFX],
    "roles": {
      "Director": ["Zach Lipovsky","Adam B. Stein"],
      "Writers": ["Zach Lipovsky","Adam B. Stein"]

    }
  },
  {
    "id": 12,
    "title": "It's Not Like That",
    "genericDescription":
      `Freshly divorced Lori and recently widowed minister Malcolm, friends with teens,
      navigate singlehood while questioning if their longstanding bond hints at a romantic future.`,
    "companyDescription":
      `Across 6 episodes and approximately 150 shots, the work covered a surprisingly broad range of visual effects
       for a drama series. Shots ranged from seasonal and environmental changes to de-aging, skin retouching,
       environment cleanup, and set extensions. Much of the work was deliberately invisible supporting
       the story and performances while keeping the final images feeling completely natural.`,
    "image": INLT,
    "video": INLTV,
    "type": [VFX],
    "roles": {
      "Creators": ["Ian Deitchman" , "Kristin Rusk Robinson"],
    }
  },
  {
    "id": 13,
    "title": "Pachinko",
    "genericDescription": 
      `The hopes and dreams of four generations of a Korean immigrant family, beginning with a story of a forbidden romance that 
      leads to a sweeping saga taking place in Korea, Japan and America.`,
    "companyDescription": 
      ``,
    "image": PKO,
    "video": PKOV,
    "type": [],
    "roles": {
      "Created by": ["Soo Hugh"],
    }
  },
  {
    "id": 14,
    "title": "The Age of A.I.",
    "genericDescription": 
      `Robert Downey Jr. hosts an exploration of the rise of artificial intelligence and showcases innovators who are pushing the boundaries.`,
    "companyDescription": 
      `The Age of AI had extensive graphic needs to showcase complex ideas. We worked on integrating graphics as well as visual effects to 
      translate those ideas into a visual medium, mixing 2d and 3d tracking with integration, text animations, automated lower thirds, and much more.`,
    "image": AI,
    "video": AIV,
    "type": [GFX],
    "roles": {
      // "Production": ["Youtube Originals", "Network Entertainment"],
    }
  },
  {
    "id": 15,
    "title": "Women Who Rock",
    "genericDescription":
      `Features interviews with several female pioneers in music and pays homage to those who have stormed the stage and wielded their instruments.`,
    "companyDescription":
      `Women who Rock needed graphics that represented the punk identity of the cast and their story. For that we went with lots of paper cutouts,
      steppy animation, and grunge textures.`,
    "image": WWR,
    "video": WWRV,
    "type": [GFX],
    "roles": {
      "Directors": ["Jessica Hopper", "Erin Cumming", "Georgia Milroy"],
      "Writers": ["Graham Kew", "Jesse James Miller", "Kristian Olsen"],
    	"Post Supervisor": ["Julie Bannon"]
    }
  },
  {
    "id": 16,
    "title": "The Twilight Zone",
    "genericDescription": 
      `An updated version of the classic anthology series featuring various tales of science fiction, mystery, and horror.`,
    "companyDescription": 
      `We were inspired by supporting this documentary, and worked in creating lighting changes and small aesthetic improvements.`,
    "image": TTZ,
    "video": TTZV,
    "type": [],
    "roles": {
      "Created by": ["Jordan Peele", "Simon Kinberg", "Marco Ramirez"],
    }
  },
  {
    "id": 17,
    "title": "Level Up",
    "genericDescription": 
      `At Gank Games, Jane and Ash do all the work without any of the recognition. 
      When the company hosts an internal pitch competition, it’s finally their chance to shine. 
      Level Up uses immersive virtual production to spotlight women in gaming, and blends office 
      satire with dark comedy to tell a story about fighting to be the boss — literally.`,
    "companyDescription": 
      `During production, we operated the virtual production stage and provided VFX supervision. 
      In post, we created both the graphics and visual effects for Level Up, doubling down on Final 
      Version 2’s strength of pairing traditional GFX with compositing. Some of the challenges were 
      finding the right level of pixelation for the graphics, and working with really tight deadlines.`,
    "image": LU,
    "video": LUV,
    "type": [VFX, GFX],
    "roles": {
      "Director": ["Gabrielle Roberts"],
      "Writer": ["Gabrielle Roberts"],
    	"VFX Supervisor": ["Ariana Saadat"]
    }
  },
  {
    "id": 18,
    "title": "My Mother, The Zombie",
    "genericDescription": 
      `After the loss of her father, 14-year-old Kiera struggles to care for her grieving mother on her own. When 
      she finds solace in the possibility of love, it unravels into something far more terrifying, bringing them closer again.`,
    "companyDescription": 
      `Crazy8s is a Vancouver prestigious film competition in which teams have a week to produce and deliver a short film. 
      In My Mother, The Zombie we had the mission to elevate the reveal of the main character’s mother (the zombie!) in order 
      to save time and budget during production, and allowing Pineda to refine with how the Mother’s eyes looked.`,
    "image": MMTZ,
    "video": MMTZV,
    "type": [VFX],
    "roles": {
      "Director": ["Samantha Pineda"],
      "Writer": ["Loretta Seto"],
    	"Post Supervisor": ["Diana NoLi"]
    }
  },{
    "id": 19,
    "title": "Come Dine With Me",
    "genericDescription":
      `Come Dine With Me Canada puts five stranger's party hosting
      skills to the test. Each contestant hosts their own dinner party, and at the end of the week one is voted the
      winner, with a 1000$ prize and the title of 'host with the most'.`,
    "companyDescription":
      `Blink49 approached us to update the original identity of the classic UK Come Dine With Me and
      bring some Canadian aspects to it. We created graphics for over fifty episodes covering scoring cards,
       lower thirds for fancy meals and competitors, and the main title opener.`,
    "image": CDWM,
    "video": CDWMV,
    "type": [GFX],
    "roles": {

    }
  },
  {
    "id": 20,
    "title": "Home Before Dark",
    "genericDescription":
      `Young investigative journalist Hilde Lisko moves with her family to the small town her father left behind,
      only to unearth big secrets in her pursuit of the truth.`,
    "companyDescription":
      ``,
    "image": HBU,
    "video": HBUV,
    "type": [VFX],
    "roles": {
      "Created by": ["Dana Fox", "Dara Resnik"],
    }
  },
  {
    "id": 21,
    "title": "Beyond the Podium: Celebrating Canadian Women Champions",
    "genericDescription":
      `A groundbreaking, feature documentary film highlighting the triumphs and tribulations of some of Canada's
       most-inspiring women winter athletes, through the lens of a women-identifying and non-binary independent filmmaking team.`,
    "companyDescription":
      `We were inspired by supporting this documentary, and worked in creating lighting changes and small aesthetic improvements.`,
    "image": POD,
    "video": PODV,
    "type": [VFX],
    "roles": {
      "Director": ["Brenda Whitehall"],
      "Writers": ["Lynda Finch", "Brenda Whitehall"],
    }
  },




]